<!--
  - Author: Raul Perusquia <raul@inikoo.com>
  - Created: Sun, 18 Feb 2024 06:25:44 Central Standard Time, Mexico City, Mexico
  - Copyright (c) 2024, Raul A Perusquia Flores
  -->

<script setup lang="ts">
import { useAppAccentVariables } from "@/Composables/useAppAccent"
import { library } from "@fortawesome/fontawesome-svg-core"
import { initialiseRetinaApp } from "@/Composables/initialiseRetinaApp"
import { useLayoutStore } from "@/Stores/retinaLayout"
import Notification from '@/Components/Utils/Notification.vue'
import { faPlug } from "@fal/faPlug";import { faStoreAltSlash } from "@fal/faStoreAltSlash";import { faNarwhal } from "@fal/faNarwhal";import { faCircle as falCircle } from "@fal/faCircle";import { faHome } from "@fal/faHome";import { faBars } from "@fal/faBars";import { faUsersCog } from "@fal/faUsersCog";import { faTachometerAltFast } from "@fal/faTachometerAltFast";import { faUser } from "@fal/faUser";import { faLanguage } from "@fal/faLanguage";import { faParachuteBox } from "@fal/faParachuteBox";import { faEnvelope } from "@fal/faEnvelope";import { faCube } from "@fal/faCube";import { faBallot } from "@fal/faBallot";import { faConciergeBell } from "@fal/faConciergeBell";import { faGarage } from "@fal/faGarage";import { faAlignJustify } from "@fal/faAlignJustify";import { faShippingFast } from "@fal/faShippingFast";import { faPaperPlane } from "@fal/faPaperPlane";import { faTasks } from "@fal/faTasks";import { faCodeBranch } from "@fal/faCodeBranch";import { faShoppingBasket } from "@fal/faShoppingBasket";import { faCheck } from "@fal/faCheck";import { faShoppingCart } from "@fal/faShoppingCart";import { faSignOutAlt } from "@fal/faSignOutAlt";import { faTimes } from "@fal/faTimes";import { faTimesCircle } from "@fal/faTimesCircle";import { faExternalLink } from "@fal/faExternalLink";import { faSeedling } from "@fal/faSeedling";import { faSnooze } from "@fal/faSnooze";import { faSkull } from "@fal/faSkull";
import { defineAsyncComponent, onBeforeMount, onBeforeUnmount, onMounted, provide, ref, watch } from 'vue'
import { useLocaleStore } from "@/Stores/locale"
const RetinaLayoutFulfilment = defineAsyncComponent(() => import("./RetinaLayoutFulfilment.vue"))
const RetinaLayoutDs = defineAsyncComponent(() => import("./RetinaLayoutDs.vue"))
const RetinaLayoutEcom = defineAsyncComponent(() => import("./RetinaLayoutEcom.vue"))
import { notify } from "@kyvg/vue3-notification"
import { usePage } from "@inertiajs/vue3"
import IrisHeader from "@/Layouts/Iris/Header.vue"
import IrisFooter from "@/Layouts/Iris/Footer.vue"

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faExclamationTriangle } from "@fal/faExclamationTriangle";import { faCheckCircle as falCheckCircle } from "@fal/faCheckCircle";import { faHeart } from "@fal/faHeart";import { faSparkles } from "@fal/faSparkles";import { faInfoCircle } from "@fal/faInfoCircle";import { faBox } from "@fal/faBox";import { faHandsHelping } from "@fal/faHandsHelping";import { faChair } from "@fal/faChair";import { faTrashAlt } from "@fal/faTrashAlt";import { faCopy } from "@fal/faCopy";import { faStickyNote } from "@fal/faStickyNote";import { faInboxIn } from "@fal/faInboxIn";import { faAppleCrate } from "@fal/faAppleCrate";import { faGift } from "@fal/faGift";import { faMedal } from "@fal/faMedal";import { faExternalLinkAlt } from "@fal/faExternalLinkAlt";
import { faExclamationTriangle as fasExclamationTriangle } from "@fas/faExclamationTriangle";import { faCheckCircle } from "@fas/faCheckCircle";import { faExclamationCircle } from "@fas/faExclamationCircle";import { faSparkles as fasSparkles } from "@fas/faSparkles";import { faInfo } from "@fas/faInfo";import { faCircle } from "@fas/faCircle";import { faMedal as fasMedal } from "@fas/faMedal";import { faCandleHolder } from "@fas/faCandleHolder";import { faCartPlus } from "@fas/faCartPlus";import { faPercent } from "@fas/faPercent";
import { faEnvelopeCircleCheck } from '@fortawesome/free-solid-svg-icons'

import Modal from "@/Components/Utils/Modal.vue"
import { ctrans } from "@/Composables/useTrans"
import Button from "@/Components/Elements/Buttons/Button.vue"
import { faSearch } from "@far/faSearch";import { faBell } from "@far/faBell";import { faPlus } from "@far/faPlus";import { faLayerGroup } from "@far/faLayerGroup";
import { faExclamationTriangle as fadExclamationTriangle } from "@fad/faExclamationTriangle";import { faMedal as fadMedal } from "@fad/faMedal";import { faSave as fadSave } from "@fad/faSave";
import { initialiseIrisVarnish } from "@/Composables/initialiseIrisVarnish"
import { setColorStyleRoot } from "@/Composables/useApp"
import { createSidePanel } from '@/Iris/Composables/useSidePanel'
import SidePanel from '@/Iris/Components/SidePanel.vue'
import { pushServerGtmEvent, pushServerGtmEventOnce } from "@/Composables/useGtm"
import { useColorTheme } from "@/Composables/useStockList"
import { computed } from 'vue'

library.add(faMedal, fasMedal, faCandleHolder, faCartPlus, fadMedal, fadSave, faLayerGroup)
library.add(faStoreAltSlash,faEnvelopeCircleCheck, fasExclamationTriangle, faExclamationTriangle, faTimesCircle, faExternalLink, fasSparkles, faSeedling, faSnooze, faSkull, falCheckCircle, faHeart, faSparkles, faExclamationCircle, faInfo, faCircle, faInfoCircle, faBox, faHandsHelping, faChair, faTrashAlt, faCopy, faStickyNote, faInboxIn, faExternalLinkAlt, faPercent, faAppleCrate, faGift)
library.add(faPlug, fadExclamationTriangle, faCheckCircle, faNarwhal, falCircle, faHome, faBars, faUsersCog, faTachometerAltFast, faUser, faLanguage, faParachuteBox, faEnvelope, faCube, faBallot, faConciergeBell, faGarage, faAlignJustify, faShippingFast, faPaperPlane, faTasks, faCodeBranch, faShoppingBasket, faCheck, faShoppingCart, faSignOutAlt, faTimes, faSearch, faBell, faPlus)


interface Notification {
    title: string
    description?: string
    message?: string
    type: 'success' | 'error' | 'info' | 'warning' | 'failure'
    status?: 'success' | 'error' | 'info' | 'warning' | 'failure'
}

const useChat = usePage().props?.use_chat
provide('layout', useLayoutStore())
provide('locale', useLocaleStore())
initialiseRetinaApp()
const layout = useLayoutStore()

onBeforeMount(() => {
    initialiseIrisVarnish(useLayoutStore)
})

// Flash: Confetti
const defaults = {
    spread: 360,
    ticks: 50,
    gravity: 0,
    decay: 0.94,
    startVelocity: 30,
    shapes: ["star"],
    zIndex: 100,
    disableForReducedMotion: false,
};

type ConfettiFn = typeof import('@tsparticles/confetti')['confetti']

const getReducedMotionAdjustments = () => {
    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    return {
        particleMultiplier: isReducedMotion ? 3 : 1,
        startVelocity: isReducedMotion ? 75 : defaults.startVelocity,
    }
}

const shootConfetti = (confetti: ConfettiFn) => {
    const { particleMultiplier, startVelocity } = getReducedMotionAdjustments()

    confetti('retina-confetti', {
        ...defaults,
        startVelocity,
        particleCount: 40 * particleMultiplier,
        scalar: 1.2,
        shapes: ["star"],
    });

    confetti('retina-confetti', {
        ...defaults,
        startVelocity,
        particleCount: 10 * particleMultiplier,
        scalar: 0.75,
        shapes: ["circle"],
    });
}

const shootMultipleConfetti = async () => {
    const { confetti } = await import('@tsparticles/confetti')

    setTimeout(() => {
        setTimeout(() => shootConfetti(confetti), 0)
        setTimeout(() => shootConfetti(confetti), 100)
        setTimeout(() => shootConfetti(confetti), 200)
        setTimeout(() => shootConfetti(confetti), 300)
    }, 500);
}

// Flash: Confetti
watch(() => usePage().props?.flash?.confetti, (newVal) => {
    // console.log('confettixx ret', newVal)
    if (!newVal) return

    shootMultipleConfetti()
}, {
    deep: true,
    immediate: true
})

// Flash: GTM
watch(() => usePage().props?.flash?.gtm, (newValue) => {
    if (!newValue?.event) return

    const hasPushedEvent = pushServerGtmEventOnce(newValue.event, newValue.data_to_submit)

    if (hasPushedEvent && newValue.event === 'purchase') {
        console.log('Purchased✅')
    }
}, {
    deep: true,
    immediate: true
})


// Flash: Modal
interface Modal {
    title: string
    description: string
    type: 'success' | 'error' | 'info' | 'warning'
}
const selectedModal = ref<Notification | null>(null)
const isModalOpen = ref(false)
watch(() => usePage().props?.flash?.modal, (modal: Notification) => {
    // console.log('modal ret', modal)
    if (!modal) return

    selectedModal.value = modal
    isModalOpen.value = true
}, {
    deep: true,
    immediate: true
})


// Flash: Notification
watch(() => usePage().props?.flash?.notification, (notification: Notification) => {
    // console.log('ret', notification)
    if (!notification) return

    setTimeout(() => {
        notify({
            title: notification.title ?? '',
            text: notification.description || notification.message,
            type: notification.type || notification.status,
        })
    }, 500);
}, {
    deep: true,
    immediate: true
})


// Section: To open/close the mobile menu
const isOpenMenuMobile = ref(false)
provide('isOpenMenuMobile', isOpenMenuMobile)


// Method: Hide the superchat widget
const hideSuperchatWidget = () => {
    const time = ref(0)
    const xxInterval = setInterval(() => {
        time.value += 150
        // const _superchatWidget = document.querySelector('#superchat-widget')
        const _superchatWidget = document.querySelector('#cookiescript_badge')
        if (_superchatWidget) {
            _superchatWidget.style.display = 'none'
            clearInterval(xxInterval)
        }

        // To safety if GTM exist but don't have superchat
        if (time.value > 7000) {
            clearInterval(xxInterval)
        }
    }, 900)
}


watch(
  () => usePage().url,
  (newUrl, oldUrl) => {
    if (layout.iris?.is_logged_in) {
      layout?.recordWebsiteHit()
    }
  },
  { immediate: true }
)

// Section: Screen Type
const screenType = ref<'mobile' | 'tablet' | 'desktop'>('desktop')
const checkScreenType = () => {
    const width = window.innerWidth
    if (width < 640) screenType.value = 'mobile'
    else if (width >= 640 && width < 1024) screenType.value = 'tablet'
    else screenType.value = 'desktop'
}
provide('screenType', screenType)
createSidePanel(layout, screenType, !!useChat)
onMounted(() => {
    checkScreenType()
    window.addEventListener('resize', checkScreenType)
})
onBeforeUnmount(() => {
    window.removeEventListener('resize', checkScreenType)
})


const getTextColorDependsOnStatus = (status: string) => {
    switch (status) {
        case 'success':
            return 'text-green-500'
        case 'error':
        case 'failure':
            return 'text-red-500'
        case 'warning':
            return 'text-yellow-500'
        case 'info':
            return 'text-gray-500'
        default:
            return ''
    }
}
const getBgColorDependsOnStatus = (status: string) => {
    switch (status) {
        case 'success':
            return 'bg-green-100'
        case 'error':
        case 'failure':
            return 'bg-red-100'
        case 'warning':
            return 'bg-yellow-100'
        case 'info':
            return 'bg-gray-100'
        default:
            return ''
    }
}

onMounted(() => {
    // if (layout.iris?.is_have_gtm) {
    setColorStyleRoot(layout?.app?.theme)
    hideSuperchatWidget()
    // }
})

const fallbackTheme = useColorTheme[3]

const safeTheme = computed(() => {
    const t = layout?.app?.theme

    return (t && t.length >= 8) ? t : fallbackTheme
})

useAppAccentVariables(() => safeTheme.value)
</script>

<template>
    <!-- Retina: Ds -->
    <RetinaLayoutDs
        v-if="layout.retina?.type === 'dropshipping'"
    >
        <template #default>
            <slot />
        </template>
    </RetinaLayoutDs>

    <!-- Retina: Ecom -->
    <RetinaLayoutEcom
        v-else-if="layout.retina?.type === 'b2b'"
    >
        <template #default>
            <slot />
        </template>
    </RetinaLayoutEcom>

    <!-- Retina: Fulfilment -->
    <template v-else-if="layout.retina?.type === 'fulfilment'">
        <RetinaLayoutFulfilment v-if="layout.user">
            <template #default>
                <slot />
            </template>
        </RetinaLayoutFulfilment>

        <template v-else>
            <IrisHeader
                v-if="layout.iris?.header?.header"
                class="relative z-50 md:z-0"
                :data="layout.iris.header"
                :colorThemed="irisTheme"
                :menu="layout.iris.menu"
            />

            <slot />

            <IrisFooter :colorThemed="irisTheme" />
        </template>
        <!-- <main v-else
            class="bg-gray-50 min-h-screen pt-16 pb-10 mx-auto flex justify-center transition-all px-8 lg:px-0"
        >
            <div class="bg-white border border-gray-300 w-full mx-auto max-w-5xl shadow-lg rounded-md h-fit relative flex flex-col text-gray-700">
                <slot name="default" />
            </div>
        </main> -->
    </template>

    <div v-else class="fixed inset-0 bg-slate-100 flex items-center justify-center">
        <slot />
    </div>

    <Modal :isOpen="isModalOpen" aonClose="isModalOpen = false" width="w-full max-w-lg">
        <div class="flex min-h-full items-end justify-center text-center sm:items-center px-2 py-3">
            <div class="relative transform overflow-hidden rounded-lg bg-white text-left transition-all w-full"
                :class="getTextColorDependsOnStatus(selectedModal?.status)"
            >
                <div>
                    <div class="mx-auto flex size-12 items-center justify-center rounded-full bg-gray-100"
                        :class="getBgColorDependsOnStatus(selectedModal?.status)"
                    >
                        <FontAwesomeIcon v-if="selectedModal?.status == 'error' || selectedModal?.status == 'failure'" icon='fal fa-times' class="text-red-500 text-2xl" fixed-width aria-hidden='true' />
                        <FontAwesomeIcon v-if="selectedModal?.status == 'success'" icon='fal fa-check' class="text-green-500 text-2xl" fixed-width aria-hidden='true' />
                        <FontAwesomeIcon v-if="selectedModal?.status == 'warning'" icon='fas fa-exclamation' class="text-orange-500 text-2xl" fixed fixed-width aria-hidden='true' />
                        <FontAwesomeIcon v-if="selectedModal?.status == 'info'" icon='fas fa-info' class="text-gray-500 text-2xl" fixed-width aria-hidden='true' />
                    </div>

                    <div class="mt-3 text-center sm:mt-5">
                        <div as="h3" class="font-semibold text-2xl">
                            {{ selectedModal?.title }}
                        </div>
                        <div v-if="selectedModal?.description" class="mt-2 text-sm opacity-75">
                            {{ selectedModal?.description }}
                        </div>
                        <div v-if="selectedModal?.message" class="mt-2 text-sm opacity-75">
                            {{ selectedModal?.message }}
                        </div>
                    </div>
                </div>

                <div class="mt-5 sm:mt-6">
                    <Button
                        @click="() => isModalOpen = false"
                        :label="ctrans('Okay')"
                        full
                    />
                </div>
            </div>
        </div>
    </Modal>

    <!-- Global declaration: Notification -->
    <notifications
        dangerously-set-inner-html
        :max="3"
        xwidth="500"
        classes="custom-style-notification"
        :pauseOnHover="true"
    >
        <template #body="props">
            <Notification :notification="props" />
        </template>
    </notifications>

    <SidePanel :isChatEnabled="!!useChat" />
</template>

<style lang="scss">
// * {
//     --color-primary: v-bind('safeTheme[0]');
// }

/* For Notification */
.custom-style-notification {
    @apply mt-2 bg-white rounded-md mr-3;

    .notification-title {
        @apply font-bold
    }

    .notification-content {
        @apply text-sm
    }

    &.success {
        @apply bg-lime-50 border-l-8 border border-lime-300 text-lime-600
    }
    &.warning {
        @apply bg-yellow-50 border-l-8 border border-yellow-400  text-amber-600
    }
    &.info {
        @apply bg-gray-100 border-l-8 border border-slate-500  text-slate-500
    }
    &.error {
        @apply bg-red-400 border-l-8 border border-red-600 text-white
    }
    &.failure {
        @apply bg-red-400 border-l-8 border border-red-600 text-white
    }
}

/* Navigation: Aiku */
.navigationActive {
    @apply rounded py-2 font-semibold transition-all duration-0 ease-out;
}

.navigation {
    @apply hover:bg-gray-300/40 py-2 rounded font-semibold transition-all duration-0 ease-out;
}

.subNavActive {
    @apply bg-indigo-200/20 sm:border-l-4 sm:border-indigo-100 text-white font-semibold transition-all duration-0 ease-in-out;
}

.subNav {
    @apply hover:bg-white/80 text-gray-100 hover:text-indigo-500 font-semibold transition-all duration-0 ease-in-out
}

.navigationSecondActive {
    @apply transition-all duration-100 ease-in-out;
}

.navigationSecond {
    @apply hover:bg-gray-100 text-gray-400 hover:text-gray-500 transition-all duration-100 ease-in-out
}

.primaryLink {
    background: v-bind('`linear-gradient(to top, #fcd34d, #fcd34d)`');

    &:hover,
    &:focus {
        color: #374151;
    }

    @apply focus:ring-0 focus:outline-none focus:border-none bg-no-repeat [background-position:0%_100%] [background-size:100%_0.2em] motion-safe:transition-all motion-safe:duration-200 hover:[background-size:100%_100%] focus:[background-size:100%_100%] px-1 py-0.5
}

.secondaryLink {
    background: v-bind('`linear-gradient(to top, ${safeTheme[6]}, ${safeTheme[6] + "AA"})`');

    &:hover,
    &:focus {
        color: v-bind('`${safeTheme[7]}`');
    }

    @apply focus:ring-0 focus:outline-none focus:border-none bg-no-repeat [background-position:0%_100%] [background-size:100%_0.2em] motion-safe:transition-all motion-safe:duration-200 hover:[background-size:100%_100%] focus:[background-size:100%_100%] px-1 py-0.5
}

// For icon box in FlatTreemap
.specialBox {
    background: v-bind('`linear-gradient(to top, ${safeTheme[0]}, ${safeTheme[0] + "AA"})`');
    color: v-bind('`${safeTheme[0]}`');
    border: v-bind('`4px solid ${safeTheme[0]}`');

    &:hover,
    &:focus {
        color: v-bind('`${safeTheme[1]}`');
    }

    @apply border-indigo-300 border-2 rounded-md cursor-pointer focus:ring-0 focus:outline-none focus:border-none bg-no-repeat [background-position:0%_100%] [background-size:100%_0em] motion-safe:transition-all motion-safe:duration-100 hover:[background-size:100%_100%] focus:[background-size:100%_100%] px-1;
}

.vue-notification-group {
    width: 300px !important;

    @media (min-width: 640px) {
        width: 500px !important;;
    }
}

.p-message-text {
    width: 100%;
}

#retina-confetti {
    pointer-events: none;
}

.text-primary {
  color: v-bind("layout.iris.theme.color[4]") ;
}
</style>
